import { useState } from 'react';

const identity = value => value;

export const useFilter = _ref => {
  let {
    initialSearchTerm,
    onFilterChange,
    externalSearchTerm,
    filterable,
    filterCallback
  } = _ref;
  const [internalFilter, setInternalFilter] = useState(initialSearchTerm);
  const filterValue = onFilterChange ? externalSearchTerm : internalFilter;
  const filter = filterable ? filterCallback : identity;
  return {
    filterValue,
    filter,
    setInternalFilter
  };
};